export const showMessage = (text: string) => {
  const x = document.createElement('div');
  // @ts-ignore
  x.style =
    'left: 50%;transform: translate(-50%, -50%);background-color: #000333b0;color: #fff;text-align: center;border-radius: 5px;padding: 14px 28px;position: fixed;z-index: 10000;left: 50%;bottom: 30px;';
  x.innerHTML = text;
  document.body.appendChild(x);

  setTimeout(function() {
    x.remove();
  }, 3000);
};

export const showMessageWithCopyButton = (text: string, onCopy: () => void) => {
  const x = document.createElement('div');
  // @ts-ignore
  x.style =
    'left: 50%;transform: translate(-50%, -50%);background-color: #000333b0;color: #fff;text-align: center;border-radius: 5px;padding: 14px 7px 14px 28px;position: fixed;z-index: 10000;left: 50%;bottom: 30px;';
  x.innerHTML = text;
  document.body.appendChild(x);

  const copyBtn = document.createElement('button');
  // @ts-ignore
  copyBtn.style =
    'margin-left: 32px;padding: 7px 14px;border-radius: 5px;background: transparent;color: white; border: 1px solid white';
  copyBtn.onclick = () => {
    onCopy();
    x.remove();
  };
  copyBtn.innerHTML = 'Zkopírovat do schránky';
  x.appendChild(copyBtn);

  const closeBtn = document.createElement('button');
  // @ts-ignore
  closeBtn.style =
    'font-size: 150%;margin-left: 14px;padding: 7px 14px;border-radius: 5px;background: transparent;color: white; border: none';
  closeBtn.onclick = () => {
    x.remove();
  };
  closeBtn.innerHTML = '×';
  x.appendChild(closeBtn);
};
